import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// helpers
import {
  addVideo as addVideoApi,
  updateVideo as updateVideoApi,
  getVideo as getVideoApi,
  deleteVideo as deleteVideoApi,
} from "../../helpers/";

// actions
import {
  videoApiResponseSuccess,
  videoApiResponseError,
  getVideo as getVideoAction,
} from "./actions";

// constants
import { VideoActionTypes } from "./constants";

interface videoData {
  payload: {
    id: number;
    name: string;
    day: string;
    video: File;
    subCourseId: string;
  };
  type: string;
}

function* createVideo({
  payload: { name, day, video, subCourseId },
  type,
}: videoData): SagaIterator {
  try {
    const response = yield call(addVideoApi, {
      name,
      day,
      video,
      subCourseId,
    });

    const videoData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      videoApiResponseSuccess(VideoActionTypes.CREATE_VIDEO, videoData)
    );
    yield put(getVideoAction());
  } catch (error: any) {
    yield put(videoApiResponseError(VideoActionTypes.CREATE_VIDEO, error));
  }
}

function* updateVideo({
  payload: { id, name, day, video, subCourseId },
}: videoData): SagaIterator {
  try {
    const response = yield call(updateVideoApi, id, {
      name,
      day,
      video,
      subCourseId,
    });
    const videoData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      videoApiResponseSuccess(VideoActionTypes.UPDATE_VIDEO, videoData)
    );
    yield put(getVideoAction());
  } catch (error: any) {
    yield put(videoApiResponseError(VideoActionTypes.UPDATE_VIDEO, error));
  }
}

function* getVideo(): SagaIterator {
  try {
    const response = yield call(getVideoApi);
    
    const videoData = response?.data?.videos;

    yield put(videoApiResponseSuccess(VideoActionTypes.GET_VIDEO, videoData));
  } catch (error: any) {
    yield put(videoApiResponseError(VideoActionTypes.GET_VIDEO, error));
  }
}

function* deleteVideo({ payload: { id } }: videoData): SagaIterator {
  try {
    const response = yield call(deleteVideoApi, id);
    const videoData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      videoApiResponseSuccess(VideoActionTypes.DELETE_VIDEO, videoData)
    );
    yield put(getVideoAction());
  } catch (error: any) {
    yield put(videoApiResponseError(VideoActionTypes.DELETE_VIDEO, error));
  }
}

export function* watchCreateVideo() {
  yield takeEvery(VideoActionTypes.CREATE_VIDEO, createVideo);
}
export function* watchUpdateVideo() {
  yield takeEvery(VideoActionTypes.UPDATE_VIDEO, updateVideo);
}
export function* watchGetVideo() {
  yield takeEvery(VideoActionTypes.GET_VIDEO, getVideo);
}

export function* watchDeleteVideo() {
  yield takeEvery(VideoActionTypes.DELETE_VIDEO, deleteVideo);
}

function* videoSaga() {
  yield all([
    fork(watchCreateVideo),
    fork(watchUpdateVideo),
    fork(watchDeleteVideo),
    fork(watchGetVideo),
  ]);
}

export default videoSaga;
